import { setEmail } from '../../../creators/Login.creators';
import * as React from 'react';
import { connect } from 'react-redux';
import { VALIDATE } from 'src/api';
import axios from 'src/axios';
import ValidationMessage from 'src/components/moleculesLegacy/ValidationMessage';

export interface ValidateEmailProps {
  token: string;
  setEmail: (email: string) => void;
}

export const ValidateEmail: React.FC<ValidateEmailProps> = ({
  token,
  setEmail: setEmailRedux,
}) => {
  const [response, setResponse]: any = React.useState(false);
  const [error, setError]: any = React.useState();

  const validateEmail = async () => {
    try {
      const validationResponse: {
        data: any;
        status: number;
      } = await axios.put(`${VALIDATE}`, { token });

      if (
        validationResponse &&
        validationResponse.data &&
        validationResponse.status === 200
      ) {
        setResponse(validationResponse.data.data);
        return;
      }
    } catch (err) {
      setError(err);
    }
  };

  if (!token || token.length === 0) {
    return <ValidationMessage showPortalLogin={response.showPortalLogin} />;
  }

  if (error) {
    return <ValidationMessage showPortalLogin={response.showPortalLogin} />;
  }

  if (!response) {
    return (
      <ValidationMessage
        validateEmail={validateEmail}
        showPortalLogin={response.showPortalLogin}
      />
    );
  }

  return (
    <ValidationMessage
      feedback={false}
      success={true}
      setEmailRedux={setEmailRedux}
      email={response.newEmail}
      showPortalLogin={response.showPortalLogin}
    />
  );
};

export default connect(() => ({}), { setEmail })(ValidateEmail);
